import { createSelector } from 'reselect';

import type { RootState } from 'typesafe-actions';
import type { BannerState } from './reducer';

export const getBanner = (state: RootState) => state.banner;

export const getIsFetching = createSelector(getBanner, (state: BannerState) => state.isFetching);
export const getIsError = createSelector(getBanner, (state: BannerState) => state.isError);

export const getSPItem = createSelector(getBanner, (state: BannerState) =>
  state.items?.find((item) => item.device === 'SP'),
);

export const getPCItem = createSelector(getBanner, (state: BannerState) =>
  state.items?.find((item) => item.device === 'PC'),
);
